import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {TheBorder} from "../../TheBorder";
import {TimelineLite} from "gsap";

export class TheBorderMaxWinRunner implements SimplePresentation {
    public shouldRun(): boolean {
        return TheBorder.model.brokeBank;
    }

    public start(controller: SimplePresentationRunnerController): void {
        const tl: TimelineLite = new TimelineLite();

        tl.add(() => {
            controller.setSkipCallback();
            TheBorder.keypadPlugin.setWin(TheBorder.model.data.accumulatedRoundWin, true, TheBorder.isWinBelowStake());
        });

        tl.add(TheBorder.maxWin.playMaxWin(() => {
            TheBorder.keypadPlugin.setWin(TheBorder.model.data.accumulatedRoundWin, true, TheBorder.isWinBelowStake());
            TheBorder.xRipButton.show();

            controller.finish();
        }));
    }
}